import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4babfb14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mk-card-block" }
const _hoisted_2 = { class: "select-container" }
const _hoisted_3 = { class: "select-item" }
const _hoisted_4 = {
  key: 1,
  class: "tips"
}
const _hoisted_5 = { class: "selected" }
const _hoisted_6 = { class: "select-title" }
const _hoisted_7 = { class: "select-data" }
const _hoisted_8 = { class: "search-warp" }
const _hoisted_9 = { class: "scroll__container" }
const _hoisted_10 = { class: "model-item mg-b--10" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "text--right" }

import { ref, reactive, onMounted, getCurrentInstance, watch, computed, nextTick } from "vue";
import { useBrandsByUser, usePlatformsByUser } from '@/utils/cacheData'
import { getModel2 } from '@/api/common'
import { debounce, deepCloneByJSON, getArrByReduce, unique } from "@/utils/tools";
import { elMessage, getTextWidth } from "@/utils";
import { useCommon } from '@/store/useCommon'
import { Search } from '@element-plus/icons-vue'
import { useI18n } from "vue-i18n";
type ResType = {
  code: string,
  data: any,
  [propName: string]: any
}

// 获取登录人信息

export default /*#__PURE__*/_defineComponent({
  __name: 'TheModel',
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  data: {
    type: Array,
    default: () => []
  },
  apkList: {
    type: Array,
    default: []
  },
  searchFormData: {
    type: Object,
    default: {
      cid: [],
      pid: [],
    },
  }
},
  setup(__props) {

const props = __props;

const { t } = useI18n()
const { emit } = getCurrentInstance()
const checkREF = ref(null)

const store = useCommon()
const user = store.userData

let Visible = ref(false)
watch(() => props.visible, val => {
  Visible.value = val
  if (val) {
    checkBox.cities = [...props.apkList]
    getBrand()
    getPlatform()
  }
}, { immediate: true })
const loading = ref(false)
const validateCid = (rule, value, callback) => {
  if (!value) {
    callback(new Error(t('请选择品牌')))
  }
  callback()
}
const validatePid = (rule, value, callback) => {
  if (!value) {
    callback(new Error(t('请选择平台')))
  }
  callback()
}
// 选择model弹框
const editModel = reactive({
  toolbar: [],
  dialogOptions: {
    fullscreen: false,
    title: '选择Model',
    width: '70%',
  },
  formlist: [
    {
      prop: 'cid',
      label: '选择品牌',
      list: [],
      widgetType: 'Select',
      multiple: true,
      disabled: false,
      collapseTags: true,
      collapseTagsTooltip: true,
      labelWidth: '130px',
      filterable: true
    },
    {
      prop: 'pid',
      label: '选择平台',
      list: [],
      multiple: true,
      widgetType: 'Select',
      collapseTags: true,
      collapseTagsTooltip: true,
      labelWidth: '130px',
      filterable: true
    },
  ],
  rules: {
    cid: [
      { required: true, validator: validateCid, trigger: 'change' },
    ],
    pid: [
      { required: true, validator: validatePid, trigger: 'change' },
    ]
  },
  formdata: {
    cid: [],
    pid: [],
  },
  search: () => {
    getModelData()
  }
})

// 回显已选的所有数据
const allSelecteds = reactive({
  data: [],
  ids: []
})

// 所有model数据
const cityOptions = ref([])
const checkBox = reactive({
  checkAll: false,            //  是否全选
  checkedCities: [],          //  已选择数据
  cities: cityOptions.value,   //  可选数据
  isIndeterminate: true,
})

const onClose = () => {
  emit('update:visible', false)
  emit('on-close')
  if (user.cid[0] > 0) {
    const { cid } = user
    editModel.formdata.cid = []
    editModel.formdata.cid.push(String(cid[0]))
  }
}
const reset = () => {
  if (user.cid[0] > 0) {
    editModel.formdata.cid.push(editModel.formlist[0].list[0].value)
  }
}
// 获取Model数据
onMounted(() => {
  // checkBox.cities = [...props.apkList]
  // getBrand()
  // getPlatform()
})
// 获取品牌数据
const getBrand = async () => {
  const brands = await useBrandsByUser()
  editModel.formlist[0].list = brands.map(item => (
    {
      label: item.prefixName,
      value: String(item.cid)
    }
  ))
  if (user.cid[0] > 0) {
    editModel.formlist[0].disabled = true
    editModel.formdata.cid = [String(brands[0].cid)]
    return
  }
  // editModel.formdata.cid = props.searchFormData.cid.map(item => String(item))
}
// 获取平台数据
const getPlatform = async () => {
  const platform = await usePlatformsByUser()
  editModel.formlist[1].list = platform.map(item => {
    return {
      label: item.prefixName,
      value: String(item.pid)
    }
  })
  // editModel.formdata.pid = props.searchFormData.pid.map(item => String(item))
}

const flag = ref(true)
const getModelData = async () => {
  if (editModel.formdata.cid.length !== 0 || editModel.formdata.pid.length !== 0) {
    loading.value = true
    checkBox.cities = []
    checkBox.checkedCities = []
    allSelecteds.ids = []

    // 本地查询model
    if (user.model) {
      console.log('查询本地model')
      const { cid, pid } = editModel.formdata
      let models = user.model.filter(ii => {
        return (cid.length > 0 ? cid.includes(String(ii.cid)) : true) && (pid.length > 0 ? pid.includes(String(ii.pid)) : true)
      })
      cityOptions.value = models
      checkBox.cities = [...props.apkList, ...models]
      loading.value = false
      // 回显已选数据
      flag.value = false
      echoData(models)
    } else {
      console.log('查询远程model', editModel.formdata)
      // 查询远程model
      const cids = editModel.formdata.cid.join(',')
      const pids = editModel.formdata.pid.join(',')
      const res = await getModel2({ cids, pids, limit: 1000 }) as ResType
      cityOptions.value = res.data
      checkBox.cities = [...props.apkList, ...res.data]
      loading.value = false
      // 回显已选数据
      flag.value = false
      echoData(res.data)
    }
  } else {
    elMessage('warning', '请选择筛选数据')
  }
}
// 回显已选数据
const echoData = (data) => {

  // 获取已经选择的id
  let ids = getArrByReduce(allSelecteds.data, 'id')

  // 从所有已选数据中筛选需要回显的数据
  // checkBox.checkedCities = data.filter(item => ids.includes(item.id))
  allSelecteds.ids = allSelecteds.data.map((item) => {
    return {
      cid: item.cid,
      mid: item.mid,
      pid: item.pid
    }
  })
  checkBox.checkedCities = data.filter(item => {
    let findItem = allSelecteds.ids.find((find) => {
      return item.cid == find.cid && item.mid == find.mid && item.pid == find.pid
    })
    return findItem ? true : false
  })
  // allSelecteds.ids = getArrByReduce(allSelecteds.data, 'id')
  handleCheckedModelChange(checkBox.checkedCities)
}

// 是否勾选
// const isCheck = id => {
//   return allSelecteds.ids.includes(id)
// }

const isCheck = checkItem => {
  let findItem = allSelecteds.ids.find((item) => {
    return item.cid == checkItem.cid && item.mid == checkItem.mid && item.pid == checkItem.pid
  })
  return findItem ? true : false
}

// 点击确定按钮
const editModelConfirm = () => {
  emit('update:data', JSON.parse(JSON.stringify(allSelecteds.data)))
  emit('update:visible', false)
}

// 点击全选按钮
const handleCheckAllChange = (val) => {
  if (val) {
    let filterData = [...checkBox.cities]
    allSelecteds.data.forEach(item => {
      let findIndex = filterData.findIndex((find) => {
        return item.cid == find.cid && item.mid == find.mid && item.pid == find.pid
      })
      if (findIndex > -1) filterData.splice(findIndex, 1)
    })
    allSelecteds.data = [...allSelecteds.data, ...filterData]
    allSelecteds.ids = [...allSelecteds.data, ...filterData]
  } else {
    let filterData = [...checkBox.cities]
    filterData.forEach(item => {
      let findIndex = allSelecteds.data.findIndex((find) => {
        return item.cid == find.cid && item.mid == find.mid && item.pid == find.pid
      })
      if (findIndex > -1) allSelecteds.data.splice(findIndex, 1)
    })
    allSelecteds.ids = [...allSelecteds.data]
  }
  // allSelecteds.data = val ? JSON.parse(JSON.stringify(checkBox.cities)) : []
  // allSelecteds.data = val ? unique(deepCloneByJSON(checkBox.cities).concat(allSelecteds.data), 'id') : cancelSelect(allSelecteds.data, checkBox.cities)
  // 手动回显
  echoData(checkBox.cities)
  // 如果使用深拷贝，没法实现全选视觉效果。浅拷贝的话，如果删除右侧数据，左侧数据又会同步删掉
  // 所以只能使用上面的手动回显方式
  // checkBox.checkedCities = val ? JSON.parse(JSON.stringify(checkBox.cities)) : []
  checkBox.isIndeterminate = false
}

// 取消已选数据
const cancelSelect = (originList = [], targetList = []) => {
  let cancelIds = getArrByReduce(targetList, 'id')
  return originList && originList.filter(originItem => !cancelIds.includes(originItem.id))
}

// 点击多选框
const handleCheckedModelChange = (value) => {
  changeIsIndeterminate()
  if (!value.length && !checkBox.cities.length) {
    checkBox.checkAll = false
  }
}
// 删除已选数据操作
const handleClose = (tag) => {
  let findItemIndex = allSelecteds.data.findIndex((item) => {
    return item.cid == tag.cid && item.mid == tag.mid && item.pid == tag.pid
  })
  let findItemIndex1 = checkBox.checkedCities.findIndex((item) => {
    return item.cid == tag.cid && item.mid == tag.mid && item.pid == tag.pid
  })
  allSelecteds.data.splice(findItemIndex, 1)
  checkBox.checkedCities.splice(findItemIndex1, 1)
  handleCheckedModelChange(checkBox.checkedCities)
  // allSelecteds.data = cancelSelect(allSelecteds.data, [tag])
  // checkBox.checkedCities = cancelSelect(checkBox.checkedCities, [tag])
}

const changeIsIndeterminate = () => {
  let time = 0
  checkBox.cities.forEach(item => {
    let findItemIndex = allSelecteds.data.findIndex(find => {
      return item.cid == find.cid && item.mid == find.mid && item.pid == find.pid
    })
    if (findItemIndex > -1) time = time + 1
  })
  checkBox.checkAll = time === checkBox.cities.length
  checkBox.isIndeterminate = checkBox.cities.length && time < checkBox.cities.length && allSelecteds.data.length ? true : false
}

const checkBoxChange = (val, data) => {
  // if (val) {
  //   allSelecteds.data.push(data)
  // } else {
  //   allSelecteds.data = cancelSelect(allSelecteds.data, [data])
  // }
  let findItemIndex = allSelecteds.data.findIndex(item => {
    return item.cid == data.cid && item.mid == data.mid && item.pid == data.pid
  })
  if (findItemIndex == -1) {
    allSelecteds.data.push(data)
  } else {
    allSelecteds.data.splice(findItemIndex, 1)
  }
  changeIsIndeterminate()
}
watch(() => props.visible, (val) => {
  if (val) {
    allSelecteds.data = JSON.parse(JSON.stringify(props.data))
    // 如果是vno用户，禁用选用品牌
    if (user.cid[0] > 0) {
      editModel.formlist[0].disabled = true
    } else {
      editModel.formlist[0].disabled = false
    }
    // 回显已选数据
    echoData(checkBox.cities)
  }
}, { immediate: true })

const modelNameKey = ref('')
const modelFilterData = ref([])
const filterModelMethodsDebounce = debounce(() => {
  filterModelMethods(allSelecteds.data)
}, 300)
const filterModelMethods = (data) => {
  if (modelNameKey.value) {
    modelFilterData.value = data && data.filter(item => item.modelName && item.modelName.toUpperCase().includes(modelNameKey.value.toUpperCase()))
  } else {
    modelFilterData.value = data || []
  }
}

watch(() => allSelecteds.data, val => {
  filterModelMethodsDebounce()
}, {
  immediate: true,
  deep: true
})

//  内容超出时显示提示
const tipDisabled = ref(false)
const showTextTip = (e) => {
  const target = e.target
  const width = getTextWidth(target.innerText)
  tipDisabled.value = target.offsetWidth > width
}


return (_ctx: any,_cache: any) => {
  const _component_search_form = _resolveComponent("search-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(Visible),
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(Visible) ? (Visible).value = $event : Visible = $event)),
    title: _ctx.$t('选择Model'),
    width: "70%",
    top: "4vw",
    onClose: onClose,
    "destroy-on-close": "",
    "close-on-click-modal": false,
    "append-to-body": "",
    "lock-scroll": false
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_button, {
          class: "mk-op-btn mk-op-btn-non-focus",
          onClick: onClose
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('关闭')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "mk-op-btn mk-op-btn-main",
          onClick: editModelConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('确定')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_search_form, {
        formList: editModel.formlist,
        formData: editModel.formdata,
        formRules: editModel.rules,
        onSearch: editModel.search,
        onReset: reset,
        gutter: 20
      }, null, 8, ["formList", "formData", "formRules", "onSearch"]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_checkbox, {
              class: "all-select",
              modelValue: checkBox.checkAll,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkBox.checkAll) = $event)),
              indeterminate: checkBox.isIndeterminate,
              onChange: handleCheckAllChange
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('本页全选')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "indeterminate"]),
            (checkBox.cities.length > 0)
              ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                  key: 0,
                  class: "check-group",
                  modelValue: checkBox.checkedCities,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checkBox.checkedCities) = $event)),
                  onChange: handleCheckedModelChange,
                  ref_key: "checkREF",
                  ref: checkREF
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkBox.cities, (city) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: city,
                        label: city,
                        checked: isCheck(city),
                        onChange: ($event: any) => (checkBoxChange($event, city)),
                        class: "checkbox"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_popover, {
                            "popper-class": "self-popper",
                            width: "auto",
                            disabled: tipDisabled.value,
                            placement: "top",
                            trigger: "hover",
                            content: city.modelName
                          }, {
                            reference: _withCtx(() => [
                              _createElementVNode("span", {
                                class: "check-name",
                                onMouseover: showTextTip
                              }, _toDisplayString(city.modelName), 33)
                            ]),
                            _: 2
                          }, 1032, ["disabled", "content"])
                        ]),
                        _: 2
                      }, 1032, ["label", "checked", "onChange"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('暂无数据')), 1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('已选数据')), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_input, {
                  "prefix-icon": _unref(Search),
                  class: "mg-b--15",
                  modelValue: modelNameKey.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelNameKey).value = $event)),
                  onInput: _unref(filterModelMethodsDebounce),
                  clearable: ""
                }, null, 8, ["prefix-icon", "modelValue", "onInput"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelFilterData.value, (model, index) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_el_popover, {
                      "popper-class": "self-popper",
                      width: "auto",
                      disabled: tipDisabled.value,
                      placement: "top",
                      trigger: "hover",
                      content: model.modelName
                    }, {
                      reference: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "model-name",
                          onMouseover: showTextTip
                        }, _toDisplayString(model.modelName), 33)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "content"]),
                    _createElementVNode("span", {
                      class: "iconfont icon-cuo",
                      onClick: ($event: any) => (handleClose(model))
                    }, null, 8, _hoisted_11)
                  ]))
                }), 256))
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})